<template>
    <div class="col-12">
        <h4>
            No results match the applied filters. Please try adjusting the
            filters.
        </h4>
    </div>
</template>

<script>
export default {
    name: "NoProductsCard"
};
</script>

<style scoped></style>
